module.exports = __webpack_public_path__ + "static/media/2FA.344fc514.png";